module.exports = __webpack_public_path__ + "img/visitor.d6783994.svg";